module.exports = __webpack_public_path__ + "img/news1-1.a8aa3d14.png";